import React from 'react';
import { Dropdown, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined, LaptopOutlined } from '@ant-design/icons';
import { useTheme } from '../../../hooks/useTheme';
import type { ThemeMode } from '../../../stores/slices/settingsSlice';

const iconStyle: React.CSSProperties = { fontSize: 16, color: 'rgba(255,255,255,0.85)' };

const modeConfig: Record<ThemeMode, { icon: React.ReactNode; label: string }> = {
  light: { icon: <SunOutlined style={iconStyle} />, label: 'Светлая тема' },
  dark: { icon: <MoonOutlined style={iconStyle} />, label: 'Тёмная тема' },
  system: { icon: <LaptopOutlined style={iconStyle} />, label: 'Системная тема' },
};

export const ThemeToggle: React.FC = () => {
  const { themeMode, setThemeMode } = useTheme();

  const current = modeConfig[themeMode];

  const items = (Object.keys(modeConfig) as ThemeMode[]).map((mode) => ({
    key: mode,
    icon: modeConfig[mode].icon,
    label: modeConfig[mode].label,
    onClick: () => setThemeMode(mode),
    style: mode === themeMode ? { fontWeight: 600, backgroundColor: 'rgba(255,255,255,0.08)' } : undefined,
  }));

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Tooltip title={current.label} placement="bottom">
        <button
          className="header-button"
          type="button"
          aria-label={current.label}
        >
          {current.icon}
        </button>
      </Tooltip>
    </Dropdown>
  );
};
